import { useEffect } from 'react';
import * as Routes from '@/modules/routes';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { IStudent } from '../types';
import useGradesTableStore from '../store/useGradesTableStore';

const byFirstAndLastName = (s1: IStudent, s2: IStudent) => {
  const lastNameCompare = s1.last_name.localeCompare(s2.last_name);

  if (lastNameCompare) return lastNameCompare;

  return s1.first_name.localeCompare(s2.first_name);
};

const useStudents = () => {
  const classroom = useGradesTableStore(state => state.classroom);
  const setStore = useGradesTableStore(state => state.setStore);

  const query = useQuery(['Students', classroom.id], () => {
    const path = Routes.plato_api_classroom_students_path(classroom.id, {
      includes: ['lti_user_ids', 'user_google_id'],
      only: ['id', 'first_name', 'last_name', 'has_lms_account'],
    });

    return axios
      .get<{ data: IStudent[] }>(path)
      .then(res => res.data.data.sort(byFirstAndLastName))
      .catch(err => console.error(err))
      .finally(() => setStore({ isLoadingStudents: false }));
  }, { enabled: !!classroom.id, placeholderData: [] });

  useEffect(() => {
    setStore({ students: query.data || [] });
  }, [query.data]);

  return { ...query, data: query.data || [] };
};

export default useStudents;
